export default {
  homePage: 'Главная страница',
};
